<template>
  <div class="browser-head">
    <div class="browser-tab">
      <img
        :src="getValue('favicon_url')"
        alt="favicon"
        height="15"
        class="h-[15px] mr-1"
      />
      {{ tabName }}
    </div>
    <div class="browser-address-bar">
      <div>{{ url }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { injectUseTenantCustomization } from "./useTenantCustomization";

const { getValue } = injectUseTenantCustomization();

defineProps({
  tabName: { type: String, default: "" },
  url: { type: String, default: "" }
});
</script>

<style lang="scss">
.browser-head {
  background: #c2c2c2;
  position: relative;
  padding-top: 10px;
  .browser-address-bar {
    width: 100%;
    padding: 5px 16px;
    background: #eeeeee;
    div {
      border-radius: 20px;
      background: #fff;
      border: 1px solid #ccc;
      border-bottom: none;
      width: 100%;
      height: 20px;
      padding: 0 10px;
      color: #c2c2c2;
    }
  }
  .browser-tab {
    background: #eeeeee;
    border: 1px solid #ccc;
    border-bottom: 0;
    border-radius: 15px 15px 0 0;
    height: 35px;
    padding: 0 16px;
    display: inline-flex;
    align-items: center;
  }
}
</style>
